import { render, staticRenderFns } from "./shareMain.vue?vue&type=template&id=87f50aac&scoped=true&"
import script from "./shareMain.vue?vue&type=script&lang=js&"
export * from "./shareMain.vue?vue&type=script&lang=js&"
import style0 from "./shareMain.vue?vue&type=style&index=0&id=87f50aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f50aac",
  null
  
)

export default component.exports